import { render, staticRenderFns } from "./AccountCallback.vue?vue&type=template&id=400a2b20&"
import script from "./AccountCallback.vue?vue&type=script&lang=js&"
export * from "./AccountCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports